import { useMemo } from 'react'

export default function useDataTransform(props) {
  return useMemo(() => {
    return Array.from({ length: 60 }, (_, i) => i + 1)
  }, [])
}
